/**
 * The query string for URL debug switches (`?firehoseStub=1`, `?proto=1`,
 * `?clubState=`, `?beta=`, `?stubCompanion=`, `?setComparePreview=1`). Empty in
 * a production build, so neither swimset.club nor the app's bundled copy ever
 * honors one; Vite replaces `import.meta.env.DEV` with a constant at build time,
 * so no `import.meta` reaches the classic-script dist-ios bundle.
 *
 * `?showcase=1` is not a debug switch (it is the public showcase's back-compat
 * link) and is read from `location.search` directly in nav.ts.
 */
export function debugSearch(): string {
  if (!import.meta.env.DEV || typeof window === "undefined") return "";
  return window.location.search;
}
